export class AllocationPool
{
    start: string;
    end: string;
}
